import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import { workPaneNarrowerThan } from "work/_views/work-pane-layout";

/**
 * The grid column a tab seats a `DocumentListReadonly` in, which decides how wide the list can be.
 *
 * `DocumentListReadonly` asks for `width: 100%`, but every tab that draws one seats it in a grid
 * item inside a non-wrapping row, and a grid item with no size is as wide as its content. So "100%"
 * was the width of the longest filename, the list's 32rem floor resolved against that same column
 * and floored nothing, and on a phone the download button stopped wherever the filename did — 80px
 * short of the pane's edge on an archived proposal (#5907). On a phone-width pane the column takes
 * the row instead, and the list's own 42rem cap is what limits it. Only there: a desktop's work
 * pane is often "compact" already, with the navigation drawer open, and the list there keeps the
 * width it has always had.
 */
const DocumentListColumn = styled(Grid)(({ theme }) => ({
  [workPaneNarrowerThan(theme.breakpoints.values.sm)]: {
    flexBasis: 0,
    flexGrow: 1,
    minWidth: 0,
  },
}));

export default DocumentListColumn;
